<script>
	import { productStore } from '../stores/products.store';
	import ProductCard from '../lib/components/ProductCard.svelte';
</script>

<section class="section all-products" id="products">
	<div class="top container">
		<h1>All Products</h1>
	</div>
	<div class="product-center container">
		{#each $productStore || [] as item}
			<ProductCard {item} />
		{/each}
	</div>
</section>
